import React, { useEffect, useState } from "react";
import Modal from "../Modal/Modal";
import Modal2 from "../Modal/Modal2";
import "./Blogs.css";

const Blogs = () => {

  return (
    <div className="blog-container " id="blog">

      <Modal/>
      <Modal2/>

      <div className="blog-header">
        <h2 className="text-center">Blog</h2>
      </div>
      <div className="blog-content container row w-full mx-auto">

            <div className="first-blog col-lg-6 col-md-6 col-sm-12 mb-5">
                  <div className="blog-image">
                      <img type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop" src='https://i.ibb.co/kyS0GVb/pexels-alex-green-5699466.png' alt="" />
                  </div>
                  <div className="blog-text">
                      <h1>
                      Tips for Preparing for Your First Therapy Session
                      </h1>
                  </div>
              </div>

            <div className="first-blog col-lg-6 col-md-6 col-sm-12">
                  <div className="blog-image" data-bs-toggle="modal" data-bs-target="#exampleModal">
                      <img src='https://i.ibb.co/zsWc67x/blog2.jpg' className="blog-img2" alt="" />
                  </div>
                  <div className="blog-text">
                      <h1>
                      "Your friends are not your therapists, and your therapist is not your friend."
                      </h1>
                  </div>
              </div>
      </div>
    </div>
  );
};

export default Blogs;
